/**
 * 高德地图API工具类
 */

class AmapHelper {
    constructor() {
        // 高德Web服务API基础URL
        this.baseUrl = 'https://restapi.amap.com/v3';
        // 这里需要配置你的高德API Key
        this.apiKey = '92aa3c1752e1f5b8252c742a3e03880d'; // 请替换为实际的API Key
    }

    /**
     * 地理编码 - 地址转坐标
     * @param {string} address 地址
     * @param {string} city 城市名称（可选）
     * @returns {Promise} 返回Promise对象
     */
    async geocode(address, city = '') {
        try {
            const params = new URLSearchParams({
                key: this.apiKey,
                address: address,
                city: city,
                output: 'json'
            });

            const response = await fetch(`${this.baseUrl}/geocode/geo?${params}`);
            const data = await response.json();

            if (data.status === '1' && data.geocodes && data.geocodes.length > 0) {
                const geocode = data.geocodes[0];
                return {
                    success: true,
                    data: {
                        longitude: geocode.location.split(',')[0],
                        latitude: geocode.location.split(',')[1],
                        formatted_address: geocode.formatted_address,
                        province: geocode.province,
                        city: geocode.city,
                        district: geocode.district,
                        level: geocode.level
                    }
                };
            } else {
                return {
                    success: false,
                    message:'地址解析失败'
                };
            }
        } catch (error) {
            console.error('地理编码请求失败:', error);
            return {
                success: false,
                message: '网络请求失败'
            };
        }
    }

    /**
     * 逆地理编码 - 坐标转地址
     * @param {number} longitude 经度
     * @param {number} latitude 纬度
     * @param {number} radius 搜索半径，单位米，默认1000
     * @returns {Promise} 返回Promise对象
     */
    async regeocode(longitude, latitude, radius = 1000) {
        try {
            const params = new URLSearchParams({
                key: this.apiKey,
                location: `${longitude},${latitude}`,
                radius: radius,
                extensions: 'all',
                output: 'json'
            });

            const response = await fetch(`${this.baseUrl}/geocode/regeo?${params}`);
            const data = await response.json();

            if (data.status === '1' && data.regeocode) {
                const regeocode = data.regeocode;
                const addressComponent = regeocode.addressComponent;
                
                return {
                    success: true,
                    data: {
                        formatted_address: regeocode.formattedAddress,
                        province: addressComponent.province,
                        city: addressComponent.city,
                        district: addressComponent.district,
                        township: addressComponent.township,
                        street: addressComponent.street,
                        streetNumber: addressComponent.streetNumber,
                        adcode: addressComponent.adcode,
                        country: addressComponent.country,
                        level: regeocode.level
                    }
                };
            } else {
                return {
                  success: false,
                  message: '坐标解析失败'
                }
            }
        } catch (error) {
            console.error('逆地理编码请求失败:', error);
            return {
                success: false,
                message: '网络请求失败'
            };
        }
    }
}

// 创建单例实例
const amapHelper = new AmapHelper();

export default amapHelper;